import { TranslocoPipe, provideTranslocoScope, translate } from '@jsverse/transloco';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { LoadingSpinner } from 'design-system';

export interface RevenueReceiptAllocatedItem {
  documento: string;
  descrizione: string;
  importo: number;
}

export interface RevenueReceiptAdvanceExpenseItem {
  codiceCliente: string;
  importo: number;
}

export interface RevenueReceiptDialogData {
  numero: string;
  cliente: string;
  metodo: string;
  importo: number;
  partiteImputate: RevenueReceiptAllocatedItem[];
  accontiSpese: RevenueReceiptAdvanceExpenseItem[];
  emailInviata: boolean;
  email: string;
  loading?: boolean;
  onDownloadPdf?: () => void;
}

@Component({
  providers: [provideTranslocoScope('receipts')],
  selector: 'rev-receipts-receipt-dialog-component',
  imports: [TranslocoPipe, LoadingSpinner, MatButtonModule, MatDialogModule],
  templateUrl: './receipts-receipt-dialog-component.html',
  styleUrl: './receipts-receipt-dialog-component.scss',
})
export class receiptsReceiptDialogComponent {
  loading: boolean;
  errorMessage: string | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: RevenueReceiptDialogData,
    private readonly dialogRef: MatDialogRef<receiptsReceiptDialogComponent>,
    private readonly router: Router,
  ) {
    this.loading = data.loading === true;
  }

  get title(): string {
    return this.loading || this.errorMessage ? translate<string>('receipts.ui.confermaIncasso') : translate<string>('receipts.ui.ricevuta');
  }

  showResult(data: RevenueReceiptDialogData): void {
    Object.assign(this.data, data);
    this.loading = false;
    this.errorMessage = null;
    this.dialogRef.disableClose = false;
  }

  showError(message: string): void {
    this.loading = false;
    this.errorMessage = message;
    this.dialogRef.disableClose = false;
  }

  close(): void {
    this.dialogRef.close();
  }

  formatAmount(value: number): string {
    return `€ ${value.toLocaleString('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  tornaAllaHome(): void {
    this.dialogRef.close();
    void this.router.navigate(['/incassi']);
  }
}
